import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class NumberFieldInput extends React.PureComponent {
    static propTypes = {
        /** html id required to connect the input with the label */
        id: PropTypes.string.isRequired,

        /** Label contents, usually text */
        label: PropTypes.node.isRequired,

        /** Text to be used for the input placeholder */
        placeholder: PropTypes.string,

        /** The input's value. Use only when the input is controlled */
        value: PropTypes.string,

        /** Disables the field */
        isDisabled: PropTypes.bool,

        /** Marks the field as required; Adds required styling to label */
        isRequired: PropTypes.bool,

        /** Marks and styles the field as invalid */
        isInvalid: PropTypes.bool,

        /** Contents of the error message, usually text */
        errorText: PropTypes.node,

        /** Ref to be passed to the input */
        innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.node]),

        /** If true, the input will gain focus when it mounts */
        shouldFocusOnMount: PropTypes.bool,

        /** Additional className added to outer container for custom styling */
        className: PropTypes.string,

        /** Adds an additional aria-describedby id. This is already used to link
        * errorText with the input */
        ariaDescribedby: PropTypes.string
    };

    static defaultProps = {
        isDisabled: false,
        value: undefined,
        placeholder: undefined,
        isRequired: false,
        isInvalid: false,
        errorText: undefined,
        innerRef: undefined,
        className: undefined
    };

    constructor(props) {
        super(props);

        this.inputWrapperRef = React.createRef();
    }

    componentDidMount() {
        const { shouldFocusOnMount } = this.props;

        this.timeout = setTimeout(() => {
            if (shouldFocusOnMount && this.inputWrapperRef) {
                this.inputWrapperRef.current.querySelector('input').focus();
            }
        }, 0);
    }

    componentWillUnmount() {
        // Safety in case of render thrashing
        clearTimeout(this.timeout);
    }

    render() {
        const {
            id,
            label,
            isDisabled,
            value,
            placeholder,
            isRequired,
            isInvalid,
            errorText,
            innerRef,
            className,
            shouldFocusOnMount,
            ariaDescribedby,
            ...rest
        } = this.props;

        let describedBy = errorText || ariaDescribedby ? '' : null;

        if (errorText) {
            describedBy = `${id}-error ${describedBy}`;
        }

        if (ariaDescribedby) {
            describedBy = `${ariaDescribedby} ${describedBy}`;
        }

        return (
            <div
                data-component="NumberFieldInput"
                className="sarsa-number-field-input sarsa-field-outer-container">
                <div className="sarsa-field-inner-container">
                    <div
                        ref={this.inputWrapperRef}
                        className="sarsa-field-input-wrapper">
                        <input
                            className={cx('sarsa-text-field-input', {
                                'is-invalid': isInvalid
                            })}
                            type="text"
                            id={id}
                            ref={innerRef}
                            disabled={isDisabled}
                            value={value}
                            placeholder={placeholder}
                            required={isRequired}
                            aria-label={label}
                            aria-invalid={isInvalid}
                            aria-describedby={describedBy}
                            {...rest} />
                    </div>
                </div>
            </div>
        );
    }
}
